import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faPlus } from '@fortawesome/free-solid-svg-icons';
import ModalCriarInventario from './ModalCriarInventario';

interface BotaoCriarInventarioProps {
    tipo: 'importar' | 'manual';
    disabled?: boolean;
}

const BotaoCriarInventario: React.FC<BotaoCriarInventarioProps> = ({ tipo, disabled }) => {
    const [showModal, setShowModal] = useState(false);

    const isImportar = tipo === 'importar';

    return (
        <>
            <Button
                variant={isImportar ? "primary" : "success"}
                size="lg"
                className="w-100"
                onClick={() => setShowModal(true)}
                disabled={disabled}
            >
                <FontAwesomeIcon icon={isImportar ? faFileImport : faPlus} className="me-2" />
                {isImportar ? 'Importar Estoque Controlado' : 'Criar Inventário Vazio'}
            </Button>

            <ModalCriarInventario
                show={showModal}
                onHide={() => setShowModal(false)}
                modalAction={tipo}
            />
        </>
    );
};

export default BotaoCriarInventario; 